import { render, staticRenderFns } from "./ProviderItem.vue?vue&type=template&id=03f3c07c&scoped=true&"
import script from "./ProviderItem.vue?vue&type=script&lang=js&"
export * from "./ProviderItem.vue?vue&type=script&lang=js&"
import style0 from "./ProviderItem.vue?vue&type=style&index=0&id=03f3c07c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03f3c07c",
  null
  
)

export default component.exports